import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowLeft } from '@phosphor-icons/react';

export default function CGU() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <div className="max-w-4xl mx-auto px-6 py-12">
        <Link to="/" className="inline-flex items-center gap-2 text-muted-foreground hover:text-primary mb-8">
          <ArrowLeft size={20} />
          Retour à l'accueil
        </Link>
        
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
        >
          <h1 className="text-4xl font-bold mb-8">Conditions Générales d'Utilisation</h1>
          <p className="text-muted-foreground mb-8">Dernière mise à jour : Décembre 2025</p>
          
          <div className="prose prose-invert max-w-none space-y-8">
            <section>
              <h2 className="text-2xl font-semibold mb-4">1. Objet</h2>
              <p className="text-muted-foreground leading-relaxed">
                Les présentes Conditions Générales d'Utilisation (CGU) régissent l'utilisation de la plateforme SIMBLYO, 
                accessible à l'adresse simblyo.com. En utilisant nos services, vous acceptez sans réserve les présentes conditions.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">2. Description des services</h2>
              <p className="text-muted-foreground leading-relaxed">
                SIMBLYO est une plateforme SaaS de génération de contenu marketing et SEO assistée par intelligence artificielle. 
                Nos services incluent :
              </p>
              <ul className="list-disc list-inside text-muted-foreground mt-4 space-y-2">
                <li>Génération de contenu pour réseaux sociaux (Instagram, Facebook, etc.)</li>
                <li>Création de pages SEO optimisées pour le référencement</li>
                <li>Génération de scripts vidéo pour le marketing</li>
                <li>Suivi des positions Google</li>
                <li>Outils d'analyse et de recommandations SEO</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">3. Inscription et compte utilisateur</h2>
              <p className="text-muted-foreground leading-relaxed">
                Pour accéder à nos services, vous devez créer un compte en fournissant des informations exactes et complètes. 
                Vous êtes responsable de la confidentialité de vos identifiants de connexion et de toutes les activités 
                effectuées sous votre compte.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">4. Utilisation acceptable</h2>
              <p className="text-muted-foreground leading-relaxed">
                Vous vous engagez à utiliser SIMBLYO de manière légale et éthique. Il est strictement interdit de :
              </p>
              <ul className="list-disc list-inside text-muted-foreground mt-4 space-y-2">
                <li>Générer du contenu illégal, diffamatoire, ou portant atteinte aux droits d'autrui</li>
                <li>Utiliser le service pour du spam ou des pratiques de référencement abusives</li>
                <li>Tenter de contourner les mesures de sécurité de la plateforme</li>
                <li>Revendre ou redistribuer l'accès à nos services sans autorisation</li>
                <li>Publier de faux avis ou témoignages</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">5. Propriété intellectuelle</h2>
              <p className="text-muted-foreground leading-relaxed">
                Le contenu généré via SIMBLYO vous appartient. Cependant, la plateforme, son code, son design et sa marque 
                restent la propriété exclusive de SIMBLYO. Vous bénéficiez d'une licence d'utilisation non exclusive 
                et non transférable de nos services.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">6. Tarification et paiement</h2>
              <p className="text-muted-foreground leading-relaxed">
                Les tarifs de nos abonnements sont affichés sur notre page de tarification. Le paiement s'effectue 
                via Stripe, plateforme de paiement sécurisée. Les abonnements sont renouvelés automatiquement sauf 
                résiliation de votre part avant la date de renouvellement.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">7. Résiliation</h2>
              <p className="text-muted-foreground leading-relaxed">
                Vous pouvez résilier votre abonnement à tout moment depuis votre espace personnel. La résiliation 
                prend effet à la fin de la période d'abonnement en cours. SIMBLYO se réserve le droit de suspendre 
                ou résilier un compte en cas de violation des présentes CGU.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">8. Limitation de responsabilité</h2>
              <p className="text-muted-foreground leading-relaxed">
                SIMBLYO fournit ses services "en l'état". Nous ne garantissons pas de résultats spécifiques en termes 
                de référencement ou d'acquisition de clients. Notre responsabilité est limitée au montant de votre 
                abonnement sur les 12 derniers mois.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">9. Avis et témoignages</h2>
              <p className="text-muted-foreground leading-relaxed">
                Les avis publiés sur SIMBLYO proviennent exclusivement d'utilisateurs vérifiés ayant un compte actif. 
                Nous n'autorisons pas les faux avis. Tout avis frauduleux sera supprimé et pourra entraîner la 
                suspension du compte concerné.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">10. Modifications des CGU</h2>
              <p className="text-muted-foreground leading-relaxed">
                SIMBLYO se réserve le droit de modifier les présentes CGU. Les utilisateurs seront informés par 
                email de toute modification substantielle. L'utilisation continue du service après modification 
                vaut acceptation des nouvelles conditions.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">11. Droit applicable et juridiction</h2>
              <p className="text-muted-foreground leading-relaxed">
                Les présentes CGU sont régies par le droit français. Tout litige relatif à l'interprétation ou 
                l'exécution des présentes sera soumis aux tribunaux compétents de Paris, France.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">12. Contact</h2>
              <p className="text-muted-foreground leading-relaxed">
                Pour toute question concernant ces CGU, vous pouvez nous contacter à : contact@simblyo.com
              </p>
            </section>
          </div>
        </motion.div>
      </div>
    </div>
  );
}
